import { useAuthContext } from '../internal/AuthContext';
export function useIsScoped(scope) {
  const {
    scopes
  } = useAuthContext();
  return scopes.has(scope);
}